/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var BreakdownType;
(function (BreakdownType) {
    BreakdownType["BY_HOUR"] = "by_hour";
    BreakdownType["BY_DAY_OF_WEEK"] = "by_day_of_week";
    BreakdownType["BY_30_DAYS"] = "by_30_days";
})(BreakdownType || (BreakdownType = {}));
